import React from 'react'

import { Box, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { CompetencyGroupSelector } from 'modules/competencies/components/CompetencyGroupSelector'

import { WizardData } from './WizardData'

type Props = WizardStepRenderParams<WizardData>

export const BasicInformationStep: React.FC<Props> = ({ data, onDataChanged }) => {
  return (
    <Box gap="s16" paddingRight="s6">
      <TextField
        label={i18n.t('competencies_v3.new_competency_wizard.basic_information_step.name_input')}
        value={data.name}
        onChange={(value) => onDataChanged({ ...data, name: value })}
        mandatory
      />
      <TextArea
        label={i18n.t(
          'competencies_v3.new_competency_wizard.basic_information_step.description_input'
        )}
        value={data.description}
        onChange={(value) => onDataChanged({ ...data, description: value })}
      />
      <CompetencyGroupSelector
        value={data.competencyGroupId}
        onChange={(groupId) => onDataChanged({ ...data, competencyGroupId: groupId ?? undefined })}
      />
    </Box>
  )
}
